import { render } from "./ConditionalH3.vue?vue&type=template&id=3479a534"
import script from "./ConditionalH3.vue?vue&type=script&lang=js"
export * from "./ConditionalH3.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__